export type BibleState = {
    bibleError: null,
    biblePendingIds: Array<number>,
    bibles: Array<Bible>,
    biblesError: null,
    biblesPending: false,
    exportBibleToImanageError: null,
    exportBibleToImanagePending: false,
    postBibleError: null,
    postBiblePending: false,
}

export const state: BibleState = {
    bibleError: null,
    biblePendingIds: [],
    bibles: [],
    biblesError: null,
    biblesPending: false,
    exportBibleToImanageError: null,
    exportBibleToImanagePending: false,
    postBibleError: null,
    postBiblePending: false,
}
